<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @show="preencher()">
        <div slot="modal-title">
            Ações -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label for="Descricao">Descrição</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="descricao"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >A descrição é obrigatória</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </b-modal>
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        acao: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        descricao: { required }
    },

    data() {
        return {
            descricao: null
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                this.descricao = this.acao.descricao
            }
        },

        fecharModal() {
            this.$emit('fechar')
        },

        salvar() {
            this.$emit('salvar', this.descricao)
        }
    }
}
</script>
